import { IFormSchema } from "../types/types";

export interface MissingField {
  name: string;
  label: string;
  type: string;
}

export const getFieldsRequired = (
  pages: IFormSchema[][],
  values: any,
  step: number,
  filesContext?: { [key: string]: FileList | any }
) => {
  const activePage: IFormSchema[] = pages[step];
  const missingFields: MissingField[] = [];

  activePage
    .filter((item: IFormSchema) => item.component.type !== "file")
    .forEach((item: IFormSchema) => {
      if (item.required && !(values[item.id]?.length > 0)) {
        missingFields.push({
          name: item.component.name,
          label: item.label,
          type: item.component.type,
        });
      }
    });

  activePage
    .filter((item: IFormSchema) => item.component.type === "file" && item.required)
    .forEach((item: IFormSchema) => {
      const files = filesContext?.[item.component.name];
      if (!(files && files.length > 0)) {
        missingFields.push({
          name: item.component.name,
          label: item.label,
          type: "file",
        });
      }
    });

  const isRequired = missingFields.length > 0;

  return {
    isRequired,
    missingFields,
  };
};
